import React from "react";
import { Dropdown, makeStyles, Option, typographyStyles } from "@fluentui/react-components";
import "./OutlineControlsNonMode.css";

import type { OptionOnSelectData, SelectionEvents } from "@fluentui/react-components";
import type { OutlineMode, OutlineSortMode } from "src/types";

const options: Record<OutlineSortMode, string> = {
  book_section: "Section",
  "count-asc": "Quantity, ↑",
  "count-desc": "Quantity, ↓",
} as const;

const useStyles = makeStyles({
  option: {
    ...typographyStyles.caption1Strong,
    color: "var(--colorNeutralForeground2) !important",
    cursor: "not-allowed",
    paddingLeft: "var(--spacingHorizontalSNudge)",
  },
});

export interface OutlineControlsNonModeProps {
  expandAll: boolean;
  outlineSortMode?: OutlineSortMode;
  outlineMode: OutlineMode;
  onCollapseAll: () => void;
  onExpandAll: () => void;
  onSelectOutlineSortMode?: (mode: OutlineSortMode) => void;
}

export function OutlineControlsNonMode({
  outlineSortMode = "book_section",
  ...props
}: React.PropsWithChildren<OutlineControlsNonModeProps>) {
  const styles = useStyles();

  const handleOptionSelect = (_: SelectionEvents, data: OptionOnSelectData) =>
    props.onSelectOutlineSortMode?.(data.optionValue as OutlineSortMode);

  if (props.outlineMode !== "style") {
    return null;
  }

  return (
    <div className="outline-controls-non-mode">
      <Dropdown
        appearance="filled-darker"
        className="outline-controls-non-mode-dropdown"
        onOptionSelect={handleOptionSelect}
        selectedOptions={[outlineSortMode]}
        size="small"
        value={options[outlineSortMode]}
      >
        <Option checkIcon={<span />} className={styles.option} disabled>
          Sort by...
        </Option>
        {Object.entries(options).map(([value, label]) => (
          <Option key={value} text={label} value={value}>
            {label}
          </Option>
        ))}
      </Dropdown>
    </div>
  );
}
